<template>
  <div>
    <!-- Remove Access to Landlord Modal -->
    <hl-Modal
      v-if="isRemoveAccessToLandlordModalShown"
      class="text-center"
      iconClass="budicon-block-sign text-danger"
      title="Fjern tilgang til utleierprofil"
    >
      <p>Vennligst bekreft at din tilgang til utleieprofilen skal slettes</p>

      <div class="mt-5">
        <button class="btn btn-danger mx-2" @click="removeAccessAndClose">Bekreft</button>
        <button class="btn btn-outline-secondary mx-2" @click="toggleRemoveAccessToLandlordModal">Avbryt</button>
      </div>
    </hl-Modal>
    <!-- Remove Access to Landlord Modal -->

    <InfoCard>
      Utleierprofiler som har avtale om overføring av data til økonomisystemer kan i API-innstillinger konfigurere malen
      for KID-nummer du vil skal benyttes ved utbetaling av husleie til din(e) bankkonto.
    </InfoCard>

    <div class="row mt-4">
      <!-- <div class="col">
        <BlockContainer class="p-5">
          <h5>API-nøkkel for regnskap</h5>
          <p>Lorem ipsum dolor sit amet... Explain what it is, etc...</p>

          <div class="my-4 pt-2">
            <hl-Input label="Nickname" placeholder="Nickname"></hl-Input>
          </div>

          <div class="my-4">
            <hl-MultipleSelect
              placeholder="Velg utleieprofil"
              :options="[{ name: 'landlord1', value: '1'}, { name: 'landlord2', value: '2'}, { name: 'landlord3', value: '3'}]"
            ></hl-MultipleSelect>
          </div>

          <div class="mt-5 text-center">
            <button class="btn btn-primary" @click="createAccountingAPIKey">Opprett API-nøkkel</button>
          </div>
        </BlockContainer>
      </div> -->

      <div class="col">
        <BlockContainer class="p-5">
          <h5>KID-nummer for utbetaling med OCR</h5>
          <p>
            Konfigurer malen for KID-nummer du vil skal benyttes ved utbetaling av husleie til din(e) bankkonto. Les mer
            på
            <a href="https://husleie-no.zendesk.com/hc/no/articles/360016639960-OCR-betalinger" target="_blank"
              >denne siden.</a
            >
          </p>

          <div class="my-4 pt-2">
            <hl-SwitchWithLabels v-model="kid.mod11" onState="MOD11" offState="MOD10" />
          </div>

          <div class="mt-4 row">
            <div class="col">
              <hl-Input label="Antall siffer" placeholder="2-26" v-model="kid.length"></hl-Input>
            </div>

            <div class="col">
              <hl-Input label="Første siffer" placeholder="1-99" v-model="kid.prefix"></hl-Input>
            </div>
          </div>

          <div class="my-4">
            <hl-Input label="Forhåndsvisning" disabled :value="exampleKid"></hl-Input>
          </div>

          <div class="text-secondary">
            <small>n = siffer (0-9)</small><br />
            <small>K = kontrollsiffer (0-9)</small>
          </div>

          <div class="mt-5 text-center">
            <hl-Button :disabled="kid.saving" :loading="kid.saving" @click="saveKIDSettings"> Lagre </hl-Button>
          </div>
        </BlockContainer>
      </div>
    </div>

    <!-- <div class="mt-5">
      <BlockContainer class="p-5">
          <div class="mb-5">
              <h5>Endring av utleierprofil</h5>
          </div>
        <div v-if="isLandlordProfileOwner">
          <button
            class="btn btn-sm btn-outline-danger"
            @click="deleteLandlordProfile"
          >Slett utleierprofil</button>
        </div>

        <div v-else>
          <button
            class="btn btn-sm btn-danger mr-2"
            @click="toggleRemoveAccessToLandlordModal"
          >Fjern egen tilgang til en utleierprofil</button>
          <button
            class="btn btn-sm btn-secondary ml-2"
            @click="requestUpgradeLandlordToProfessional"
          >Be om oppgradering til profesjonell utleier</button>
        </div>
      </BlockContainer>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BlockContainer from '@/components/BlockContainer.vue';
import { ProfilesLandlordApi } from '@modules/husleieapi2';
import Input from '@modules/husleie-framework/src/components/forms/inputs/input/Input.vue';
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import SwitchWithLabels from '@modules/husleie-framework/src/components/forms/inputs/switch/SwitchWithLabels.vue';
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';
import InfoCard from '@/components/InfoCard.vue';

const api = new ProfilesLandlordApi();

export default {
  components: {
    BlockContainer,
    InfoCard,
    'hl-Modal': Modal,
    'hl-Input': Input,
    'hl-SwitchWithLabels': SwitchWithLabels,
    'hl-Button': Button,
  },

  props: {
    landlordId: [String, Number],
  },

  data() {
    return {
      kid: {
        loading: false,
        saving: false,
        mod11: false,
        length: '',
        prefix: '',
      },
    };
  },

  computed: {
    ...mapGetters(['isLandlordProfileOwner', 'isRemoveAccessToLandlordModalShown']),

    exampleKid() {
      let example = '';
      if (this.kid.length && this.kid.prefix) {
        const prefixLength = this.kid.prefix.length;
        const totalLength = parseInt(this.kid.length, 10);
        const digitsBetween = totalLength - prefixLength - 1;
        console.log(digitsBetween, this.kid);
        example += this.kid.prefix;
        for (let i = 0; i < digitsBetween; i++) {
          example += 'n';
        }
        example += 'K';
      }

      return example;
    },
  },

  watch: {
    landlordId: {
      async handler() {
        await this.getKIDSettings();
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions([
      'createAccountingAPIKey',
      'deleteLandlordProfile',
      'toggleRemoveAccessToLandlordModal',
      'requestUpgradeLandlordToProfessional',
      'removeAccessToLandlord',
    ]),

    async getKIDSettings() {
      this.kid.loading = true;
      const promises = [
        this.fetchSettingValue('structured_reference_modulus', 'mod10'),
        this.fetchSettingValue('structured_reference_length'),
        this.fetchSettingValue('structured_reference_prefix'),
      ];
      const res = await Promise.all(promises);
      this.kid.mod11 = res[0] === 'mod11';
      this.kid.length = String(res[1]);
      this.kid.prefix = String(res[2]);
      this.kid.loading = false;
    },

    async saveKIDSettings() {
      this.kid.saving = true;
      const promises = [
        this.saveSettingValue('structured_reference_modulus', this.kid.mod11 ? 'mod11' : 'mod10'),
        this.saveSettingValue('structured_reference_length', this.kid.length),
        this.saveSettingValue('structured_reference_prefix', this.kid.prefix),
      ];
      await Promise.all(promises);
      this.$toast('Instillinger for KID-nummer lagret.', 'success');
      this.kid.saving = false;
    },

    async fetchSettingValue(key, defaultValue = '') {
      try {
        const res = await api.getProfileLandlordSetting(this.landlordId, key);
        return res;
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors[0] &&
          error.response.data.errors[0].code &&
          error.response.data.errors[0].code === 404
        ) {
          return defaultValue;
        } else {
          console.error(error);
          this.$toast(`Kunne ikke hente konfigurasjonsparameter '${key}'`, 'error');
        }
      }
    },

    async saveSettingValue(key, value) {
      try {
        await api.setProfileLandlordSetting(this.landlordId, key, { body: value });
      } catch (error) {
        console.error(error);
        this.$toast(`Kunne ikke lagre konfigurasjonsparameter '${key}'`, 'error');
      }
    },

    removeAccessAndClose() {
      this.removeAccessToLandlord();
      this.toggleRemoveAccessToLandlordModal();
    },
  },
};
</script>
